<template>
  <use
    :fill="visualizationPinColor"
    xlink:href="#pin-spot-restroom-male"
  />
</template>

<script>
export default {
  props: {
    isSearched: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // NOTE: ピンのは選択状態で変わる
    visualizationPinColor() {
      let color;

      if (this.isSearched || this.isSelected) {
        // NOTE: 検索後
        color = '#108abf';
      } else {
        // NOTE: 検索前
        color = '#80d8ff';
      }

      return color;
    },
  },
};
</script>



// WEBPACK FOOTER //
// restroom_male.vue?53b52bf8